// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__+uahi","userZone":"Header_userZone__rL4f3","avatar":"Header_avatar__3eZL4","title":"Header_title__G0m2V"};